<div class="modal-header">
    <h5 class="modal-title mb-0 sd-text-primary">Product Details</h5>
    <button type="button" class="btn-close custom-close-btn" aria-label="Close" (click)="cancelPopup()"></button>
</div>

<div class="row g-3 p-3">
    <div class="col-xl-5 col-lg-5 col-md-5 col-12">
        <div class="card h-100 d-flex align-items-center justify-content-center p-3">
            <img [src]="productDetails?.image" class="img-fluid" alt="Product Image" />
        </div>
    </div>

    <div class="col-xl-7 col-lg-7 col-md-7 col-12">
        <div class="card h-100 d-flex flex-column justify-content-between">
            <div class="p-3">

                <div class="card mb-3 border">
                    <div class="custom-header fw-bold p-2" style="font-size: 14px;">
                        Item Info
                    </div>
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">Style No: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.styleNo }}</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">Bag No: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.bagNo }}</span></td>
                                </tr>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">IGI No: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.certificateNo }}</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">HUID: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.huid }}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card mb-3 border">
                    <div class="custom-header fw-bold p-2" style="font-size: 14px;">
                        Weight Breakup
                    </div>
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">Gold Purity: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.karatType }}</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">Diamond Clarity: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.clarity }}</span></td>
                                </tr>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">Gold Weight: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.grossWt }} G</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">Diamond Weight: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.diaWt }} KT</span></td>
                                </tr>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">Gold Color: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.materialColorName }}</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">Diamond Pieces: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.diaQty }}</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <div class="card mb-3 border">
                    <div class="custom-header fw-bold p-2" style="font-size: 14px;">
                        Amount Breakup
                    </div>
                    <div class="table-responsive">
                        <table class="table mb-0">
                            <tbody>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">Diamond Amount: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.diaMrp | number:'1.2-2' }} ₹</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">Gold Amount: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.goldMrp | number:'1.2-2' }} ₹</span></td>
                                </tr>
                                <tr>
                                    <td class="fw-semibold" style="font-size: 14px;">Color Stone Amount: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.colorStonePrice | number:'1.2-2' }} ₹</span></td>
                                    <td class="fw-semibold" style="font-size: 14px;">Labor Charge: <span
                                            class="fw-normal ms-2">{{
                                            productDetails?.makingCharges | number:'1.2-2' }} ₹</span></td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

                <h1 class="fw-bold mb-3" style="font-size: 14px;">
                    Total Price: ₹ {{ productDetails?.sellingPrice | number:'1.2-2' }}
                </h1>

                <div class="d-flex justify-content-between gap-2">
                    <button *ngIf="productDetails.isSameStoreProduct" class="btn sd-custom-btn rounded-2  btn-sm " (click)="createNewSalesEntry()">
                        Create New Sales Entry</button>
                    <button class="btn sd-custom-btn rounded-2  btn-sm" (click)="cancelPopup()">Cancel</button>
                </div>
            </div>
        </div>
    </div>
</div>